import React, { Component } from 'react';
import { $qsa, eventCheck } from '../../helpers/misc-javascript-helpers.js';
import { getTestimonialsData } from '../../utils/api.js'
import FeedbackItem from '../FeedbackItem/FeedbackItem.js';
import PagerComponentAsync from '../PagerComponent/PagerComponentAsync.js';
import Spinner from '../Spinner/Spinner.js';

class FeedbackResults extends Component {
    constructor(props) {
        super(props);
        this.state = {
            feedbackData: {},
            isLoading: true,
            currentPage: 1,
            lastPage: '',
            perPage: 12,
            prevButtonState: true, // disabled = true
            nextButtonState: false, // disabled = true
            loadedOnce: false
        };
        this.htmlScrollTop = document.documentElement.scrollTop; // scrolltop access for safari
        this.bodyScrollTop = document.body.scrollTop; // scrolltop access for Chrome, Firefox, IE, and Opera et al.

        this.getTestimonials = this.getTestimonialsCall.bind(this);
        this.handlePreviousClick = this.handlePreviousClick.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.handleButtonStatuses = this.handleButtonStatuses.bind(this);
        this.doPagerUpdate = this.receivePagerUpdates.bind(this);
        this.pagerInput = '';
    }

    componentDidMount = () => {
        if (this.state.loadedOnce) {
            return false;
        } else {
            this.getTestimonials();
            if ($qsa('.next-button') && $qsa('.previous-button')) {
                this.setPrevCtrlBtn($qsa('.previous-button')[0]);
                this.setNextCtrlBtn($qsa('.next-button')[0]);
            }
            this.setState({ loadedOnce: true });
        }
    }

    componentDidUpdate() {
        if (!this.state.loadedOnce) {
            this.handleLoadSequence();
        }
    }

    setPrevCtrlBtn = (buttonNode) => {
        this.topPrevButton = buttonNode;
    }

    setNextCtrlBtn = (buttonNode) => {
        this.topNextButton = buttonNode;
    }

    /**
     * @method getTestimonialsCall - get data from the url and process the request for the testimonials.
     */
    getTestimonialsCall = async () => {
        try {
            const allTestimonials = await getTestimonialsData(this.state.currentPage, this.state.perPage); // user initUrlCheck results to make request.
            let returnedData = allTestimonials.data.data;
            this.setState({ feedbackData: returnedData ? returnedData : {} });
            this.setState({ currentPage: returnedData.meta.current_page });
            this.setState({ perPage: returnedData.meta.per_page });
            this.setState({ lastPage: returnedData.meta.last_page });
            this.handleButtonStatuses();
            this.setState({ isLoading: false });
        } catch (error) {
            window.location.assign('/errors/404');
            console.error(error);
        }
    }

    /**
     * @method handlePreviousClick - handles the effect of clicking on the previous button.
     * @param {event} e 
     */
    handlePreviousClick = (e) => {
        eventCheck(e);
        if ((this.state.currentPage - 1) < 1) {
            this.setState({ currentPage });
        } else {
            this.setState({ currentPage: this.state.currentPage -= 1 });
            this.handleLoadSequence();
        };
        if (this.topPrevButton) {
            if (this.topPrevButton.disabled) {
                this.topNextButton.focus();
            } else {
                this.topPrevButton.focus();
            }
        }
    }

    /**
     * @method handleNextClick - handles the effect of clicking on the next button.
     * @param {event} e 
     */
    handleNextClick = (e) => {
        eventCheck(e);
        if ((this.state.currentPage + 1) > this.state.lastPage) {
            this.setState({ currentPage });
        } else {
            this.setState({ currentPage: this.state.currentPage += 1 });
            this.handleLoadSequence();
        };
        if (this.topNextButton) {
            if (this.topNextButton.disabled) {
                this.topPrevButton.focus();
            } else {
                this.topNextButton.focus();
            }
        }
    }

    /**
     * @method handleLoadSequence - handles the common load sequence that is required to complete the 
     * handleNextClick and handlePreviousClick actions
     * 
     */
    handleLoadSequence = () => {
        document.documentElement.scrollTop = 0; // scrolltop access for safari
        document.body.scrollTop = 0; // scrolltop access for Chrome, Firefox, IE, and Opera, et al.
        this.getTestimonials();
        this.setState({ isLoading: true });
        this.setState({ loadedOnce: true });
    }

    /**
     * @method handleButtonStatuses - handles the statuses of the page control buttons when the data loads.
     * @param {event} e 
     */
    handleButtonStatuses = () => {
        this.state.nextButtonState = (this.state.currentPage === this.state.lastPage) ? true : false;
        this.state.prevButtonState = (this.state.currentPage === 1) ? true : false;
        this.pagerInput = { prevBtnState: this.state.prevButtonState, nextBtnState: this.state.nextButtonState };
        return this.pagerInput;
    }

    /** Method bound as doPagerUpdate and passed to PagerComponent as a prop to get update messages/ data from it (child). */
    receivePagerUpdates = (update) => {
        this.pagerInput = '';
        switch (update.action) {
            case 'to-previous':
                this.handlePreviousClick({ value: 'previous' }, true);
                break;
            case 'to-next':
                this.handleNextClick({ value: 'next' }, true);
                break;
            case 'field-input':
                if (update.currentPage !== '') {
                    this.setState({ loadedOnce: false });
                    this.setState({ currentPage: update.currentPage });
                }
                break;
            case 'to-first':
                this.setState({ loadedOnce: false });
                this.setState({ currentPage: update.currentPage });
                break;
            case 'to-last':
                this.setState({ loadedOnce: false });
                this.setState({ currentPage: update.lastPage });
                break;
        }
        return update;
    }

    render = () => {
        const containerStyle = {
            'position': 'relative'
        }
        const containerStyleLoading = {
            'position': 'relative',
            'height': '500px',
            'overflow': 'hidden',
        }
        return (
            <div className="testimonials-container" style={(this.state.isLoading) ? containerStyleLoading : containerStyle}>
                <Spinner isLoading={this.state.isLoading}></Spinner>
                <div className={(this.state.isLoading) ? 'testimonials-button__row row justify-content-between is-loading' : 'testimonials-button__row row justify-content-between'}>
                    <div className="testimonials-button__layer"></div>
                    <div className="col-sm-4 col-md-3">
                        <button className="previous-button btn btn-md btn-mid-orange btn-mid-orange--cr451 bradius-0 w-100" disabled={(this.state.prevButtonState) ? 'disabled' : ''} onClick={(e) => this.handlePreviousClick(e)}><i className="fas fa-caret-left"></i> Previous</button>
                    </div>
                    <div className="col-sm-4 col-md-3">
                        <button className="next-button btn btn-md btn-mid-orange btn-mid-orange--cr451 bradius-0 w-100" disabled={(this.state.nextButtonState) ? 'disabled' : ''} onClick={(e) => this.handleNextClick(e)}>Next <i className="fas fa-caret-right"></i></button>
                    </div>
                </div>
                {typeof (this.state.feedbackData.data) !== 'undefined' ?
                    <PagerComponentAsync meta={this.state.feedbackData.meta} updateOutput={this.doPagerUpdate} updateInput={this.pagerInput}></PagerComponentAsync>
                    : ''}
                <div className="viewing-message__row row">
                    <p className={(this.state.isLoading) ? 'is-loading' : 'ubuntu text-center text-bold w-100 pt-3 pb-4'} tabIndex="0">Viewing Page <span>{this.state.currentPage}</span> of <span>{this.state.lastPage}</span></p>
                    <div className={(this.state.isLoading) ? 'is-loading' : 'rule--dotted mt-2 mb-5'}></div>
                </div>
                {(typeof (this.state.feedbackData.data) !== 'undefined') ? this.state.feedbackData.data.map((feedback, index) =>

                    <FeedbackItem key={index}
                        first_name={feedback.testimonial.first_name}
                        last_name={feedback.testimonial.last_name}
                        testimonial={feedback.testimonial.testimonial}
                        title={feedback.testimonial.title}
                        course_id={feedback.testimonial.course_id}
                        course_title={feedback.testimonial.course_title}
                        course_slug={feedback.testimonial.course_slug}
                        certificate={feedback.testimonial.parent_suite_name}
                        certificate_id={feedback.testimonial.parent_suite_id = false} // purposely set to false to hide certification information
                        certificate_slug={feedback.testimonial.parent_suite_slug}
                        multiplier={index}
                        disableLinks={false}
                    >
                    </FeedbackItem>
                ) : ''}
                <div className={(this.state.isLoading) ? 'testimonials-button__row row justify-content-between is-loading' : 'testimonials-button__row row justify-content-between mt-4'}>
                    <div className="testimonials-button__layer"></div>
                    <div className="col-sm-4 col-md-3">
                        <button className="previous-button btn btn-md btn-mid-orange btn-mid-orange--cr451 bradius-0 w-100" disabled={this.state.prevButtonState} onClick={(e) => this.handlePreviousClick(e)}><i className="fas fa-caret-left" aria-hidden="true"></i> Previous</button>
                    </div>
                    <div className="col-sm-4 col-md-3">
                        <button className="next-button btn btn-md btn-mid-orange btn-mid-orange--cr451 bradius-0 w-100" disabled={this.state.nextButtonState} onClick={(e) => this.handleNextClick(e)}>Next <i className="fas fa-caret-right" aria-hidden="true"></i></button>
                    </div>
                </div>
            </div>
        );
    }
}

export default FeedbackResults;